import React, { useEffect, useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import {
  Byline,
  ExhibitionContainer,
  Paragraph,
  SectionTitle,
  PageTitle,
  HeroImage,
  FeatureImage,
  HeroCaption,
  MasonryGallery,
  MasonryItem,
  MasonryImage
} from '../../styles/exhibitionStyles';

export default function SothebysHongKong() {


  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openLightbox = (imagePath) => {
    setCurrentImage(imagePath);
    setLightboxOpen(true);
  };

  // Masonry gallery images
  const masonryImages = [
    "/img/show-sothebys/sothebys-5.jpg",
    "/img/show-sothebys/sothebys-6.jpg",
    "/img/show-sothebys/sothebys-7.jpg",
  ];


  useEffect(() => {
    document.title = "Sotheby's Auction 2023: Contemporary Discoveries - SLEEPR";
  }, []);

  return (
    <ExhibitionContainer>
      <HeroImage src="/img/show-sothebys/sothebys-1.jpg" alt="Sotheby's Exhibition" />
      <HeroCaption>Sotheby's Hong Kong Contemporary Discoveries - March 2023</HeroCaption>

      <PageTitle>Sotheby’s Auction 2023:
      Contemporary Discoveries</PageTitle>
      <Byline>
      In 2023, Sleepr was sold at a Sotheby’s fine art auction in Hong Kong, with a collection of contemporary artists from around the world, including Jeff Koons, Damian Hirst, Takashi Murakami and more.
      </Byline>

      <FeatureImage src="/img/show-sothebys/sothebys-2.jpg" alt="The Trinket Maker" />

      <SectionTitle>Down The Rabbit Hole</SectionTitle>
      <Paragraph>
      In March 2023, Sleepr’s enigmatic work was included in the Sotheby’s Hong Kong Contemporary Discoveries collection of works up for auction. The collection of works were curated under the theme of Down The Rabbit Hole with a focus on prestigious and otherworldly works with a whimsical twist
      </Paragraph>
      <Paragraph>
      The auction at Sotheby’s marked a significant moment for the emerging artist in the realm of contemporary art, with the inclusion of the enigmatic work The Trinket Maker. As a renowned fine art auction house, Sotheby’s has a long history of curating and presenting works that push the boundaries of artistic expression. Sleepr’s inclusion in this auction underscores the artist's growing reputation and the intrigue surrounding their unique approach to art.
      </Paragraph>
      <Paragraph>
      <a href="https://www.sothebys.com/en/digital-catalogues/contemporary-discoveries-down-the-rabbit-hole">The Contemporary Discoveries collection can be found here</a>
      </Paragraph>
      <Paragraph>
      <a href="https://www.sothebys.com/en/buy/auction/2023/contemporary-discoveries-down-the-rabbit-hole/the-trinket-maker-shi-pin-jiang-ren">The Trinket Maker listing on Sotheby’s can be found here</a>
      </Paragraph>



      <FeatureImage src="/img/show-sothebys/feature1.png" alt="The Trinket Maker" />

      <SectionTitle>A Prominent Auction Of Contemporary Artists</SectionTitle>
      <Paragraph>
        The collection showcased works by influential contemporary and ultracontemporary artists such as Takashi Murakami, Damien Hirst, Jeff Koons, Mr., Matt Gondek, KAWS. A range of other prominent artists from the Asia region were also included to much success with the localized audience.
      </Paragraph>
      <Paragraph>
      The inclusion of such prominent names alongside Sleepr highlights the significance of the collection and the high caliber of artists it attracts.
      </Paragraph>


      <FeatureImage src="\img\artworks-1920\sleepr_1920_080.jpg" alt="Exhibition Space" />

      <SectionTitle>The Artwork: "The Trinket Maker"</SectionTitle>
      <Paragraph>
        "The Trinket Maker" (2023) was presented with a reserve of 40,000-60,000 HK dollars, a testament to Sleepr's growing reputation within the art world. The artwork offers a mesmerizing glimpse into a meticulously crafted studio, bathed in warm light. The studio, filled with an array of hand-made ornaments, trinkets, vases, and other objects, invites viewers to reflect on their own inner world. This setting, while seemingly mundane, is deeply symbolic, representing the mind's landscape where ideas, memories, and experiences are stored.
      </Paragraph>

      <FeatureImage src="/img/show-sothebys/sothebys-3.jpg" alt="Artwork Detail" />


      <SectionTitle>The Superflat Style and Color Palette</SectionTitle>
      <Paragraph>
        Sleepr's choice to render the scene in a superflat style, characterized by a palette of soft colors—lavenders, peach, orange, and blush yellow—imbues the work with a sense of delicate beauty. The artist's signature technique of blending semi-abstract figures and imagery with moments of realism creates a dynamic visual experience, where the boundaries between reality and abstraction are continuously negotiated.
      </Paragraph>

      <MasonryGallery>
        {masonryImages.map((image, index) => (
          <MasonryItem key={index} onClick={() => openLightbox(image)}>
            <MasonryImage src={image} alt={`Exhibition view ${index + 1}`} />
          </MasonryItem>
        ))}
      </MasonryGallery>
      
      <FeatureImage src="/img/show-sothebys/sothebys-8.png" alt="Exhibition Space" />

      <SectionTitle>Conceptual Depth and Symbolism</SectionTitle>
      <Paragraph>
        The intricacy of "The Trinket Maker" lies not just in its visual elements but in its conceptual depth. The studio is more than a physical space; it is an analogy for the viewer's mind. The complex pipework on the ceiling, rendered in meticulous detail, represents the brain's pathways, while the warm light symbolizes the consciousness that illuminates our thoughts and memories.
      </Paragraph>
      <Paragraph>
        By inviting the viewer into this richly textured world, Sleepr creates a powerful dialogue between the artwork and the audience. The piece acts as a mirror, reflecting an abstract representation of the viewer's mind, challenging them to explore the immaterial trinkets they carry within themselves. This introspective quality of the work resonates with the broader themes of Sleepr's oeuvre, which often delve into the psychological dimensions of human experience.
      </Paragraph>
      <Paragraph>
        In the context of the Sotheby's auction, "The Trinket Maker" garnered significant attention not only for its aesthetic appeal but also for its conceptual sophistication.
      </Paragraph>

      <SectionTitle>Lot 1147 Technical Notes:</SectionTitle>
      <Paragraph>
        Sleepr b. 1988 The Trinket Maker 2023
      </Paragraph>
      <Paragraph>
        Non-fungible Token ERC-721 minted on 9 February 2023, this NFT is a 1-of-1 jpg image at 12000 x 8400 pixels mint address: 0xbf817fe72263176b0623a8cae92a3a55b391e378
      </Paragraph>
      <Paragraph>
        ----------------------------------------------
      </Paragraph>
      <Paragraph>
        Sleepr 1988年生 飾品匠人 2023
      </Paragraph>
      <Paragraph>
        非同質化代幣 2023年2月9日鑄幣，此非同質化代幣為獨一無二的jpg圖像，分辨率12000 x 8400 鑄幣：0xbf817fe72263176b0623a8cae92a3a55b391e378
      </Paragraph>
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={[{ src: currentImage }]}
        carousel={{ finite: true }}
        render={{ 
          buttonPrev: () => null,
          buttonNext: () => null
        }}
      />
    </ExhibitionContainer>
  );
}
